/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_708_OptionsInputs */



/**
* | output |
* | --- |
* | "708 Options" |
*
* @param {Subtitle_Export_708_OptionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_708_options = /** @type {((inputs?: Subtitle_Export_708_OptionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_708_OptionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("708 options")
	if (locale === "de") return /** @type {LocalizedString} */ ("708 Optionen")
	if (locale === "it") return /** @type {LocalizedString} */ ("708 Opzioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("708 Вариантов")
	if (locale === "es") return /** @type {LocalizedString} */ ("708 Opciones")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("708 选项")
	if (locale === "ja") return /** @type {LocalizedString} */ ("708オプション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("708 विकल्प")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("708 Opções")
	return /** @type {LocalizedString} */ ("708 Options")
});